import { render, staticRenderFns } from "./MenuDetail.vue?vue&type=template&id=dd895104&scoped=true"
import script from "./MenuDetail.vue?vue&type=script&lang=js"
export * from "./MenuDetail.vue?vue&type=script&lang=js"
import style0 from "./MenuDetail.vue?vue&type=style&index=0&id=dd895104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd895104",
  null
  
)

export default component.exports